import { useState, useEffect } from "react";
import { isNativeApp } from "@/lib/native-setup";

export const useIsStandalone = () => {
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const standalone =
      isNativeApp() ||
      window.matchMedia("(display-mode: standalone)").matches ||
      (navigator as any).standalone === true;
    setIsStandalone(standalone);
  }, []);


  return isStandalone;
};
